import React, { useState } from "react";
import './LoginPage.css';
import GoogleLoginButton from './GoogleLoginButton'
import { useTranslation } from '../hooks/useTranslation'
import LanguageSelector from './LanguageSelector'

export const LoginPage = () => {
  const [rightPanelActive, setRightPanelActive] = useState(false);
  const { translate } = useTranslation();

  return (
    <div>
              <div className="language-selector-wrapper">
        <LanguageSelector />
      </div>
      <div id="login-page">

        <div className={`container ${rightPanelActive ? "right-panel-active" : ""}`} id="container">

          <div className="form-container sign-up-container">
            {/* ... Sign Up form unchanged ... */}
          </div>

          <div className="form-container sign-in-container">
            <form action="#">
              <h1>{rightPanelActive ? "Sign Up" : "Sign In"}</h1>
              <div className="social-container">
                {/* Google icon'u yerine bizim custom buton */}
                <GoogleLoginButton />
              </div>
              <span>or use your account</span>
              <input type="email" placeholder="Email" />
              <input type="password" placeholder="Password" />
              <a href="#">Forgot your password?</a>
              <button type="submit">{rightPanelActive ? "Sign Up" : "Sign In"}</button>
            </form>
          </div>

          {/* Overlay bölümü değişmedi */}
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>Welcome Back!</h1> {translate('about')}
                <p>To keep connected with us please login with your personal info</p>
                <button className="ghost" id="signIn" onClick={() => setRightPanelActive(false)}>Sign In</button>
              </div>
              <div className="overlay-panel overlay-right">
                <h1>Hello, Friend!</h1>
                <p>Enter your personal details and start journey with us</p>
                <button className="ghost" id="signUp" onClick={() => setRightPanelActive(true)}>Sign Up</button>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <p>
            Fourpus Software
          </p>
        </footer>
      </div>
      </div>
      );
};

/*
      <footer>
        <p>
          Created with <i className="fa fa-heart"></i> by
          <a target="_blank" rel="noreferrer" href="https://florin-pop.com">Florin Pop</a>
          - Read how I created this and how you can join the challenge
          <a target="_blank" rel="noreferrer" href="https://www.florin-pop.com/blog/2019/03/double-slider-sign-in-up-form/">here</a>.
        </p>
      </footer>

*/
